import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class SideBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news:[]

        };
      }

    componentDidMount() {
        this.getNews();
      }
    
      // Retrieves the list of items from the Express app
      getNews = () => {
        fetch('/api/news/1')
        .then(res => res.json())
        .then(news => this.setState({ news }));

      }

      prettyDate(dateString){
        //if it's already a date object and not a string you don't need this line:
        var date = new Date(dateString);
        var d = date.getDate();
        //- -var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
        var m = date.getMonth()+1;
        var y = date.getFullYear();
        return d+'.'+m+'.'+y;
    }

    render() {
        const { news } = this.state;
        
        return (
            <div className='newsSideBar floatLeft'>
                {news.length ? (
                    <div className="sideBar">
                        {/* Render the list of items */}
                        {news.map((post, i) => {
                        return(
                            <Link to={"/news/"+post.slug} key={i}>
                                <div className="newsArticle" key={i}>
                                    
                                    <p className="resourceTitle marginBotTiny">{post.headline}</p>
                                    <div className="articleInfo fullWidth clearBoth">
                    
                                        <p className="numeroText loatLeft">
                                            {this.prettyDate(post.created_at)}   
                                        </p>
                                    </div>
                                                                
                                    
                                </div>
                            </Link>
                        );
                        })}
                    </div>
                    ) : (
                        <div className="fullWidth fullHeight redT blinkFast loader">
                        <div className="centeredContent">•</div>
                    </div>
                    
                    )
                }
            </div>
        )
    }
  }
  
  export default SideBar;


// WEBPACK FOOTER //
// ./src/components/news/sidebar.js